import { RowIdentifierDto } from "@/dtos";
import { Identifier } from "@/entities";
import { getIdentifierTypeOption } from "@/helpers/options";

export const formatRowIdentifierDto = (identifiers: Identifier[]): RowIdentifierDto[] => {
    return identifiers.map(x => {
        const row: RowIdentifierDto = {
            ...x,
            type_label: getIdentifierTypeOption(x.type).label,
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}